// External imports
import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

// Internal imports
import Button from "components/atoms/Button/Button";
import Dialog from "components/organisms/Dialog/Dialog";

interface RemoveMessageDialogProps {
  isOpen: boolean;
  close: () => void;
  deleteMessage: () => void;
  isLoading: boolean;
}

const RemoveMessageDialog = function ({ isOpen, close, deleteMessage, isLoading }: RemoveMessageDialogProps) {
  const intl = useIntl();
  const { handleSubmit } = useFormContext();
  return (
    <Dialog
      show={isOpen}
      title={intl.formatMessage({
        id: "tracking.components.removeMessageDialog.confirmRemove",
        defaultMessage: "Confirm remove",
      })}
      onHide={close}
      size="sm"
    >
      <form onSubmit={handleSubmit(deleteMessage)}>
        <div className="d-flex" style={{ marginTop: 16 }}>
          <Button
            className="rounded-pill font-b1"
            variant="outline-primary"
            style={{ padding: "8px 24px" }}
            label={intl.formatMessage({
              id: "general.cancel",
              defaultMessage: "Cancel",
            })}
            onClick={close}
          />
          <Button
            disabled={isLoading}
            className="ml-auto rounded-pill font-b1"
            variant="danger"
            style={{ padding: "8px 24px" }}
            label={
              isLoading ? (
                <div className="spinner-border spinner-border-sm" role="status" />
              ) : (
                intl.formatMessage({
                  id: "general.delete",
                  defaultMessage: "Delete",
                })
              )
            }
            type="submit"
          />
        </div>
      </form>
    </Dialog>
  );
};

RemoveMessageDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  deleteMessage: PropTypes.func.isRequired,
};

export default RemoveMessageDialog;
